import Immutable from "seamless-immutable";

export const NOTIFICATION_IDS = {
	GDRIVE_RETRIEVE_FAILED: "GDRIVE_RETRIEVE_FAILED",
};

export default Immutable({
	[NOTIFICATION_IDS.GDRIVE_RETRIEVE_FAILED]: {
		id: NOTIFICATION_IDS.GDRIVE_RETRIEVE_FAILED,
		text: "google_drive.notifications.retrieve_failed",
	},
});
